import { UserType } from "@bvhi/backend-api";
import { Box, Chip } from "@bvhi/ui-base";
import { UserTypeChip } from "../../../components/common/user-type-chip";

interface Props {
  data?: UserType;
}

export const UserTypeCell = ({ data }: Props) => {
  if (!data)
    return (
      <Box>
        <Chip label="Keine Auswahl" />
      </Box>
    );

  return (
    <Box>
      <UserTypeChip size="medium" type={data} />
    </Box>
  );
};
